import React, { useState } from "react";
import product from "../../assets/product.png";
import calender from "../../assets/calender.png";
import done from "../../assets/done.png";
import statusIcon from "../../assets/orders/status.png";
import guatantee from "../../assets/orders/guatantee.png";
import { Button, Modal, Radio, Space } from "antd";
import UnderGuaranteeModal from "./UnderGuaranteeModal";
import { useTranslation } from "react-i18next";

const UnderGuaranteeOrder = ({ idOrder, image, date, time, orderStatus }) => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCancel, setIsModalCancel] = useState(false);

  const showModal = (status) => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModalCancel = () => {
    setIsModalCancel(true);
  };
  const handleOkCancel = () => {
    setIsModalCancel(false);
  };
  const handleCancelCancel = () => {
    setIsModalCancel(false);
  };

  const [value, setValue] = useState(1);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  return (
    <div>
      <div className="bg-white shadow-2xl rounded-2xl mt-4 p-4 max-lg:relative">
        <div className="lg:flex justify-between ">
          <div className="lg:flex items-center">
            {/* <img src={image} className="w-[100px] rounded-2xl" /> */}
            <div className="bg-[#FCFBFA] p-3 rounded-2xl max-lg:w-full max-lg:mx-auto max-lg:mb-3">
              <img src={image} className="w-[80px] max-lg:mx-auto" />
            </div> 
            <p className="ml-3 text-[#737E91] font-semibold max-lg:mt-3">
            {t("Order number")}
              <span className="text-[#283D63] font-semibold">#{idOrder}</span>
              <div className="flex items-center mt-3">
                <img src={calender} className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">{date} | {time}</p>
              </div>
              <div className="flex items-center mt-3">
                <img src={statusIcon} className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91]">{t("Status")}</p>
                <p className="text-[#283D63] ml-2">{t("Completed")}</p>{" "}
              </div>
            </p>
          </div>
          <div className="max-lg:absolute top-7 right-7">
            <img src={guatantee} className="w-[40px] ml-5" />
          </div>
        </div>

        <div className="flex justify-center my-5">
          <div>
            <button
              onClick={() => showModal("Complete")}
              className="bg-[#FE9B71] text-white rounded-full px-8 max-lg:px-3 h-10 mx-3"
            >
              {t("Preview order")}
            </button>
            <Modal
              title={t("Order Preview")}
              className="orderModal"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <div className="mt-6">
                <UnderGuaranteeModal idOrder={idOrder}/>
              </div>
            </Modal>
          </div>

          <div>
            <button
              onClick={showModalCancel}
              className="text-[#FE9B71] rounded-full h-10 border-2 border-[#FE9B71] px-8 max-lg:px-3"
            >
              {t("View receipt")}
            </button>

            {/* <Modal
              title="Are you sure you want to cancel?"
              className="orderModal orderModalPricing w_small_modal"
              open={isModalCancel}
              onOk={handleOkCancel}
              onCancel={handleCancelCancel}
              footer={null}
            >
              <div className="mx-5 my-5">
                <div>
                  <Radio.Group onChange={onChange} value={value} className="custome_radio custome_radio_color">
                    <Space direction="vertical">
                      <Radio value={1}>I was trying the app</Radio>
                      <Radio value={2}>
                        I will try ordering this service later
                      </Radio>
                      <Radio value={3}>
                        Appointed technician is not replying{" "}
                      </Radio>
                      <Radio value={4}>No reason</Radio>
                      <Radio value={4}>Other</Radio>
                    </Space>
                  </Radio.Group>
                </div>

                <button className="bg-[#FE9B71] text-white rounded-full py-2 px-10 flex mx-auto font-medium text-lg mt-5">
                  Cancel order
                </button>
              </div>
            </Modal> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnderGuaranteeOrder;
